<template>
  <div>
    <section>
      <b-card no-body class="shadow p-3 mb-5 bg-white rounded m-4">
        <b-tabs class="pl-4" pills vertical>
          <b-tab active>
          <template v-slot:title>
            <b-icon icon="grid" variant="primary"></b-icon> Dashboard
          </template>
            <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
              <b-card-text>
                <div class="col-3 mb-2">
                  <b-card
                    border-variant="primary"
                    header="Jumlah Produk"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    align="center"
                  >
                    <h2>{{ items.length }}</h2>
                  </b-card>
                </div>
                <div class="container">
                  <div class="row">
                    <div class="col">
                      <b-card>
                        <h2>Pertumbuhan Nasabah</h2>
                        <bar-chart :chart-data="datacollection"></bar-chart>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card>
                        <h2>Nasabah Per Produk</h2>
                        <pie-chart :chart-data="datacollection"></pie-chart>
                      </b-card>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <b-icon icon="archive" variant="primary"></b-icon> Manajemen Produk
            </template>
            <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
              <b-card-text>
                <!-- <div class="container"> -->
                  <div id="Product Management">
                    <div class="row no-gutters">
                      <div class="col-9">
                        <b-link to="/add-product">
                          <b-button type="button" variant="outline-primary">Tambah Produk</b-button>
                        </b-link>
                      </div>
                      <div class="col">
                        <div class="d-flex">
                          <div class="dropdown">
                            <button
                              class="btn btn-f-outline-blue dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >Search</button>
                          </div>
                          <input type="text" class="form-control w-50" />
                        </div>
                      </div>
                    </div>
                    <div class="overflow-auto">
                      <b-table
                      id="product-table"
                      responsive="true"
                      :items="items"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      >
                        <template v-slot:cell(jenistabungan_id)="data">
                          {{ data.item.jenistabungan_id.name }}
                        </template>
                        <template v-slot:cell(akad_id)="data">
                          {{ data.item.akad_id.name }}
                        </template>
                        <template v-slot:cell(is_publish)="data">
                          <span v-if="data.item.is_publish == 1">
                            Aktif
                            <b-icon
                              icon="toggle-on"
                              scale="2"
                              class="ml-2"
                              variant="success"
                            ></b-icon>
                          </span>
                          <span v-else>
                            Tidak Aktif
                              <b-icon
                                icon="toggle-off"
                                scale="2"
                                class="ml-2"
                                variant="danger"
                              ></b-icon>
                          </span>
                        </template>
                        <template v-slot:cell(aksi)="data">
                          <b-link :to="'/edit-product/' + data.item.id">
                            <b-icon
                              icon="eye"
                              scale="2"
                              class="mx-2"
                              variant="primary"
                            ></b-icon>
                          </b-link>
                          <a href="cms-tambahproduk.html">
                            <b-icon
                              icon="file-earmark-medical"
                              scale="2"
                              class="mx-2"
                              variant="warning"
                            ></b-icon>
                          </a>
                          <b-link @click="confirmDeleteProduct">
                            <b-icon
                              icon="trash"
                              scale="2"
                              class="mx-2"
                              variant="danger"
                            ></b-icon>
                          </b-link>
                          <b-modal size="sm" v-model="confirmDeleteModal" hide-footer hide-header>
                            <div class="d-block text-center">
                              <h3>Anda yakin ingin menghapus product ini?</h3>
                            </div>
                            <div class="row">
                              <div class="col">
                                <b-button class="mt-3" block @click="deleteProduct(data.item.id)">Ya</b-button>
                              </div>
                              <div class="col">
                                <b-button class="mt-3" block @click="cancelDeleteProduct">Tidak</b-button>
                              </div>
                            </div>
                          </b-modal>
                        </template>
                      </b-table>
                      <b-pagination
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="product-table"
                        v-model="currentPage"
                      ></b-pagination>
                    </div>

                  </div>
                <!-- </div> -->
              </b-card-text>
            </b-card>
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <b-icon icon="people" variant="primary"></b-icon> Profil Mitra
            </template>
            <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
              <b-card-text>
                <div role="group">
                  <label for="input-live">Alamat Mitra :</label>
                  <b-form-textarea id="input-live" type="text" rows="3"  :value="this.currentUser.info.mitra_profile.alamat_mitra" ></b-form-textarea>

                  <label for="input-live" class="mt-3">Nomor Akta Pendirian :</label>
                  <b-form-input id="input-live" type="number" :value="this.currentUser.info.mitra_profile.no_akta_pendirian"></b-form-input>

                  <div class="row mt-3">
                    <div class="col">
                      <label for="input-live">Logo Mitra :</label>
                      <b-form-file
                        placeholder="Pilih file atau drop file disini ..."
                        drop-placeholder="Drop file disini ..."
                      ></b-form-file>
                    </div>
                    <div class="col">
                      <label for="input-live">Gambar Tanda Tangan Penanggung Jawab :</label>
                      <b-form-file
                        placeholder="Pilih file atau drop file disini ..."
                        drop-placeholder="Drop file disini ..."
                      ></b-form-file>
                    </div>
                  </div>
                </div>
              </b-card-text>
              <b-button
                variant="success"
                class="btn btn-custom theme-color text-white mr-md-2 mr-auto px-4 rounded-0"
              >Simpan</b-button>
            </b-card>
          </b-tab>


          <b-tab>
            <template v-slot:title>
              <b-icon icon="file-earmark" variant="primary"></b-icon> Manajemen Pengajuan
            </template>
            <b-card  class="shadow-sm p-3 mb-5 bg-white rounded">
              <b-card-text>
                <!-- <div class="container"> -->
                  <div id="Pengajuan Management">
                    <div class="overflow-auto">
                      <b-table
                      id="pengajuan-table"
                      responsive="true"
                      :items="pengajuanItems"
                      :fields="pengajuanFields"
                      :current-page="currentPagePengajuan"
                      :per-page="perPagePengajuan"
                      >
                        <template v-slot:cell(product_id)="data">
                          {{ data.item.product_id.nama_produk }}
                        </template>
                        <template v-slot:cell(funder_id)="data">
                          {{ data.item.funder_id.name }}
                        </template>
                        <template v-slot:cell(status_pengajuan_id)="data">
                          {{ data.item.status_pengajuan_id.name }}
                        </template>
                        <template v-slot:cell(aksi)="item">
                          <a :href="`/produk-mitra/${item.id}`">
                            <b-icon
                              icon="eye"
                              scale="2"
                              class="mx-2"
                              variant="primary"
                            ></b-icon>
                          </a>
                          <a href="cms-tambahproduk.html">
                            <b-icon
                              icon="file-earmark-medical"
                              scale="2"
                              class="mx-2"
                              variant="warning"
                            ></b-icon>
                          </a>
                          <a href="cms-tambahproduk.html">
                            <b-icon
                              icon="trash"
                              scale="2"
                              class="mx-2"
                              variant="danger"
                            ></b-icon>
                          </a>
                          <b-button @click="changeStatus(item, index)" type="button" variant="primary">
                            <b-icon
                              icon="arrow-right-square-fill"
                              class="mx-2"
                            ></b-icon> Lanjut
                          </b-button>
                        </template>
                      </b-table>
                      <b-pagination
                        :total-rows="rowsPengajuan"
                        :per-page="perPagePengajuan"
                        aria-controls="pengajuan-table"
                        v-model="currentPagePengajuan"
                      ></b-pagination>
                    </div>
                  </div>
                <!-- </div> -->
              </b-card-text>
            </b-card>
          </b-tab>

        </b-tabs>
      </b-card>
    </section>
  </div>
</template>

<script>
import BarChart from '../../src/components/BarChart.vue'
import PieChart from '../../src/components/PieChart.vue'
import Product from '../api/produk.js';
import Pengajuan from '../api/pengajuan.js';

const fields = [
  {
    key: 'nama_produk',
    label: 'Nama Produk',
    sortable: true
  },
  {
    key: 'jenistabungan_id',
    label: 'Jenis produk',
    sortable: true
  },
  {
    key: 'akad_id',
    label: 'Akad Syariah',
    sortable: true
  },
  {
    key: 'aksi',
    label: 'Aksi',
  }
]


const pengajuanFields = [
  {
    key: 'product_id',
    label: 'Nama Produk',
    sortable: true
  },
  {
    key: 'funder_id',
    label: 'Nama nasabah',
    sortable: true
  },
  {
    key: 'status_pengajuan_id',
    label: 'Status Pengajuan',
    sortable: true
  },
  {
    key: 'aksi',
    label: 'Aksi',
  }
]

export default {
  name: "dashboardLol",
  beforeCreate: function () {
    document.body.className = "";
  },
  components: {
      BarChart,
      PieChart
  },
  data () {
      return {
        products: [],
        pengajuans: [],
        datacollection: null,
        items: [],
        pengajuanItems: [],
        fields: fields,
        pengajuanFields: pengajuanFields,
        perPage: 5,
        currentPage: 1,
        perPagePengajuan: 5,
        currentPagePengajuan: 1,
        confirmDeleteModal: false
      }
  },
  computed: {
     currentUser() {
       return this.$store.state.auth.user;
     },
     rows() {
       return this.items.length;
     },
     rowsPengajuan() {
       return this.pengajuanItems.length;
     }
  },
  mounted () {
      this.fillData();
      this.loadData();
  },
   methods: {
      fillData () {
        this.datacollection = {
          labels: [this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }, {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }
          ]
        }
      },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    loadData() {
      Product.productOnMitra(this.currentUser.info.mitra_id)
        .then(res => {
        this.items = res.data.data
        // console.log(res.data.data.length);
      })
      .catch(err => console.log(err))

      Pengajuan.pengajuanMitra()
        .then(res => {
        this.pengajuanItems = res.data.data
      })
      .catch(err => console.log(err))
    },
    changeStatus(item) {

    },
    confirmDeleteProduct() {
      this.confirmDeleteModal = true;
    },
    deleteProduct(item) {

    },
    cancelDeleteProduct() {
      this.confirmDeleteModal = false;
    }
  },


};
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>



// WEBPACK FOOTER //
// src/public/dashboard.vue